import styled from "styled-components"

export const BaseContainer = styled.span`
  display: inline-flex;
  justify-content: center;
  align-items: center;

  position: relative;
  background-color: var(--color-neutral-50);

  &.type--circle {
    border-radius: 100%;
  }
  &.type--square {
    border-radius: 4px;
  }

  &.size--small {
    width: var(--size-6);
    height: var(--size-6);
    min-width: var(--size-6);
    min-height: var(--size-6);
  }
  &.size--default {
    width: var(--size-9);
    height: var(--size-9);
    min-width: var(--size-9);
    min-height: var(--size-9);
  }
  &.size--large {
    width: var(--size-12);
    height: var(--size-12);
    min-width: var(--size-12);
    min-height: var(--size-12);
  }
  &.size--xlarge {
    width: var(--size-14);
    height: var(--size-14);
    min-width: var(--size-14);
    min-height: var(--size-14);
  }
`
export const BaseAvatar = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  .type--circle & {
    border-radius: 9999px;
  }
  .type--square & {
    border-radius: 4px;
  }
`

export const Notification = styled.span`
  display: inline-flex;
  justify-content: center;
  align-items: center;

  position: absolute;
  width: var(--size-4);
  height: var(--size-4);
  top: -6px;
  right: 0;
  border-radius: 50%;
  background-color: var(--color-primary);
  color: var(--color-text-0);
`
export const Presence = styled.span`
  position: absolute;
  width: var(--size-2);
  height: var(--size-2);
  bottom: 2px;
  right: 0;
  border-radius: 50%;
  background-color: var(--color-success);
  border: 1px solid var(--color-layout-main);
`

export const BaseAvatarGroup = styled.div`
  display: flex;
  align-items: center;

  ${BaseContainer} {
    border: 2px solid var(--color-layout-main);
    box-sizing: content-box;
  }
  ${BaseContainer}:not(:first-child) {
    &.size--small {
      margin-left: calc(-1 * var(--size-2));
    }
    &.size--default {
      margin-left: calc(-1 * var(--size-3));
    }
    &.size--large {
      margin-left: calc(-1 * var(--size-4));
    }
    &.size--xlarge {
      margin-left: calc(-1 * var(--size-5));
    }
  }
`

export const BaseGroupAction = styled.button`
  background-color: transparent;
  outline: none;
  border: none;
  padding: 0;
  margin-left: var(--size-3);
  cursor: pointer;

  > ${BaseContainer} {
    margin-left: none;
  }
`
